// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5203":"77ddae019d833612","6218":"64795a9c47fe7365"}[chunkId] + ".js";
};